import { FaTrophy } from "react-icons/fa";
import {
  comparePublicationsByDate,
  formatPillarVenueLine,
  formatWorkshopVenueLine,
  getPublicationHref,
  getWorkshopTitle,
} from "../utils/pillarContent";
import { findPublicationByTitle } from "../utils/publicationUtils";

const highlightName = (authorsStr) =>
  String(authorsStr).replace(
    /(\bKellie\s+Sim\b|\bKellie\s+Yu\s+Hui\s+Sim\b)/g,
    (match) =>
      `<span class="font-semibold underline decoration-green/70 underline-offset-2">${match.trim()}</span>`,
  );

const resolveItem = (item) => {
  const title = typeof item === "string" ? item : item?.title;
  if (!title) return null;
  return findPublicationByTitle(title) || (typeof item === "object" ? item : { title });
};

const ProjectPublicationList = ({
  title,
  items = [],
  showWorkshopTitle = false,
  headingClassName = "text-sm font-semibold text-lightText dark:text-darkText",
  className = "mt-5 sm:mt-6",
}) => {
  const resolved = items
    .map(resolveItem)
    .filter(Boolean)
    .sort(comparePublicationsByDate);

  if (!resolved.length) return null;

  return (
    <section className={className}>
      <h3 className={headingClassName}>{title}</h3>
      <ul className="mt-3 space-y-4">
        {resolved.map((pub, idx) => {
          const href = getPublicationHref(pub.links);
          const workshopTitle = showWorkshopTitle
            ? getWorkshopTitle(pub)
            : null;
          const venueLine = workshopTitle
            ? formatWorkshopVenueLine(pub)
            : formatPillarVenueLine(pub);
          return (
            <li
              key={`${pub.title}-${idx}`}
              className="border-b border-gray-200 pb-4 last:border-0 last:pb-0 dark:border-gray-700"
            >
              <p className="text-base font-semibold leading-snug text-lightText dark:text-darkText">
                {href ? (
                  <a
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-green dark:hover:text-green-dark underline underline-offset-2"
                  >
                    {pub.title}
                  </a>
                ) : (
                  pub.title
                )}
              </p>
              {pub.authors && (
                <p
                  className="mt-1 text-sm leading-relaxed text-gray-700 dark:text-gray-300 break-words"
                  dangerouslySetInnerHTML={{
                    __html: highlightName(pub.authors),
                  }}
                />
              )}
              <div className="mt-1.5 flex flex-wrap items-center gap-x-2 gap-y-1 text-sm text-gray-500 dark:text-gray-400">
                {venueLine ? (
                  <span className="min-w-0 break-words">{venueLine}</span>
                ) : null}
                {pub.award ? (
                  <span className="inline-flex items-center gap-1 font-medium text-amber-700 dark:text-amber-300">
                    <FaTrophy size={10} aria-hidden="true" />
                    {pub.award}
                  </span>
                ) : null}
                {pub.links?.slides ? (
                  <a
                    href={pub.links.slides}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-medium text-green dark:text-green-dark underline underline-offset-2"
                  >
                    Slides
                  </a>
                ) : null}
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default ProjectPublicationList;
